const DEFAULT_ITEMS = ["ELYSIUM TRAINING CLUB", "COACHING-LED FITNESS", "TRAIN WITH PURPOSE IN SWANSEA"];

export function Marquee({ items = DEFAULT_ITEMS, bgImage }) {
  const track = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-line bg-void py-6" data-testid="home-marquee">
      {bgImage && (
        <>
          <img src={bgImage} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-void/70" />
        </>
      )}
      <div className="relative flex w-max animate-marquee">
        {track.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="font-anton uppercase text-3xl sm:text-4xl tracking-tight px-6 shrink-0 [-webkit-text-stroke:1px_#9a8968] text-transparent"
          >
            {item} <span className="text-gold not-sr-only">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
